import React from 'react';

/**
 * Zeitraum-Filter: Startjahr und Endjahr auswaehlen.
 *
 * @param {object} props
 * @param {number[]} props.allYears – sortierte Liste aller verfuegbaren Jahre
 * @param {number}  props.startYear – aktuell ausgewaehlter Startwert
 * @param {number}  props.endYear   – aktuell ausgewaehlter Endwert
 * @param {function} props.onFilterChange – (startYear, endYear) Callback bei Aenderung
 */
export default function FilterBar({ allYears, startYear, endYear, onFilterChange }) {
    if (!allYears || allYears.length < 2) return null;

    return (
        <div className="filter-bar mb-3">
            <div className="filter-bar-row d-flex align-items-center gap-2 flex-wrap">
                <label className="filter-label me-1" htmlFor="pv-start-year">
                    <i className="bi bi-calendar-range me-1" />
                    Zeitraum:
                </label>

                <select
                    id="pv-start-year"
                    className="form-select form-select-sm filter-select"
                    value={startYear}
                    aria-label="Startjahr auswaehlen"
                    onChange={(e) => {
                        const v = parseInt(e.target.value, 10);
                        if (!isNaN(v) && v <= endYear) {
                            onFilterChange(v, endYear);
                        }
                    }}
                >
                    {allYears.map((y) => (
                        <option key={'s' + y} value={y}>
                            {y}
                        </option>
                    ))}
                </select>

                <span className="filter-separator mx-1">bis</span>

                <select
                    id="pv-end-year"
                    className="form-select form-select-sm filter-select"
                    value={endYear}
                    aria-label="Endjahr auswaehlen"
                    onChange={(e) => {
                        const v = parseInt(e.target.value, 10);
                        if (!isNaN(v) && v >= startYear) {
                            onFilterChange(startYear, v);
                        }
                    }}
                >
                    {allYears.map((y) => (
                        <option key={'e' + y} value={y}>
                            {y}
                        </option>
                    ))}
                </select>

                {(startYear !== allYears[0] || endYear !== allYears[allYears.length - 1]) && (
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary filter-reset mt-1"
                        onClick={() => onFilterChange(allYears[0], allYears[allYears.length - 1])}
                        title="Zeitraum zuruecksetzen"
                        aria-label="Zeitraum zuruecksetzen"
                    >
                        <i className="bi bi-arrow-counterclockwise" />
                        &nbsp;Zur&uuml;cksetzen
                    </button>
                )}
            </div>
        </div>
    );
}
